import { ev123EvcUrl } from '../lib/config';

export type Ev123LeadPayload = {
  name: string;
  phone: string;
  apartment_or_company_name: string;
  inquiry_type: string;
  message: string;
  privacy_agreed: boolean;
  email?: string | null;
};

export type Ev123LeadSuccess = { ok: true; id: number; status: string; created_at: string | null };

function formatDetail(detail: unknown): string {
  if (detail == null) return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (item && typeof item === 'object' && 'msg' in item) {
          return String((item as { msg: string }).msg);
        }
        return JSON.stringify(item);
      })
      .filter(Boolean)
      .join(' ');
  }
  if (typeof detail === 'object' && detail !== null) {
    return JSON.stringify(detail);
  }
  return String(detail);
}

/** POST /api/ev123evc/leads — 실패 시 Error throw */
export async function submitEv123Lead(payload: Ev123LeadPayload): Promise<Ev123LeadSuccess> {
  const url = ev123EvcUrl('/leads');
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const text = await res.text();
  let body: unknown;
  try {
    body = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(
      text.trim().startsWith('<')
        ? '서버가 HTML을 반환했습니다. API 프록시(/api/ev123evc) 설정을 확인해 주세요.'
        : (text.slice(0, 280) || '서버 응답을 해석할 수 없습니다.')
    );
  }
  if (!res.ok) {
    const d = body as { detail?: unknown; message?: string };
    const msg = formatDetail(d.detail) || d.message || `요청 실패 (${res.status})`;
    throw new Error(msg);
  }
  const out = body as Ev123LeadSuccess;
  if (!out.ok || typeof out.id !== 'number') {
    throw new Error('서버 응답 형식이 올바르지 않습니다.');
  }
  return out;
}
